export const MARKUP = 'markup'
export const MULTIPLIER = 'multiplier'
